import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import HomePageHeader from '../../components/home/HomePageHeader';
// Data
import {
  homePageAdditionalMeta,
  homePageStructuredData,
  websiteStructuredData,
} from '../../utils/data/MetaData';
// Components
import { HelmetItem } from '../../components/utils/HelmetItem';
import { HOME_PAGE_URL } from '../../utils/constants/Routes';
import { CompanyName } from '../../utils/constants/Constants';

const HomePage = React.memo(() => {
  return (
    <>
      {/* Tab Data */}
      {/* Tab Data */}
      <HelmetItem
        PageName='Home'
        desc={`Serve ${CompanyName}, your unapologetic Muscle Goddess and Elite Dominatrix. Explore sessions, tributes, premium links, and exclusive content for devoted submissives.`}
        keywords={`Queen Blaire, dominatrix, femdom, muscle goddess, BDSM sessions, tribute, fetish content, USA dominatrix, ${CompanyName}, domination`}
        additionalMeta={homePageAdditionalMeta}
        structuredData={[homePageStructuredData, websiteStructuredData]}
        canonicalPath={HOME_PAGE_URL}
      />
      
      {/* Page */}
      <div className='grid min-h-screen w-full overflow-hidden font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid grid-rows-reg h-full'>
          {/* Navigation */}
          <Navbar />
          <HomePageHeader />
        </div>

        {/* Main page content */}
        <HomePageMainContainer />
      </div>
    </>
  );
});

export default HomePage;
